import { IPaginationQuery, ITEMS_PER_PAGE } from '@wyz/types';
import { Form, RowModel } from '../index';
import { useDatatableContext } from './context';
const PaginationControls = <TDataItem extends RowModel>() => {
  const datatableContext = useDatatableContext<TDataItem>();

  function handleItemsPerPageChange(limit: IPaginationQuery['limit']) {
    datatableContext.internals.setter((prevState) => ({
      ...prevState,
      page: 1,
      limit: limit,
    }));
  }

  return (
    <div className='my-2 d-flex align-items-center justify-content-end'>
      <Form.Group className='d-flex align-items-center'>
        <Form.Label className='fs-sm leading-5 opacity-75 mb-0 me-1'>
          {datatableContext.translations?.pagination?.itemsPerPageSelect
            ? datatableContext.translations.pagination.itemsPerPageSelect
            : 'Items/page:'}
        </Form.Label>
        <Form.Select
          onChange={(event) =>
            handleItemsPerPageChange(
              Number(event.target.value) as IPaginationQuery['limit'],
            )
          }
          defaultValue={
            datatableContext.internals.state.limit ??
            datatableContext.defaults?.limit
          }
        >
          {ITEMS_PER_PAGE.map((count) => (
            <option key={count} value={count}>
              {datatableContext.translations?.pagination?.itemsPerPageValue
                ? datatableContext.translations?.pagination?.itemsPerPageValue(
                    count,
                  )
                : count}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </div>
  );
};

export default PaginationControls;
